<div class="basicrow tabtopb f-black roboto-r f-reg" *ngIf="this.screen==3">
        <div class="basicrow text-center m-top-ii">
            <div class="shortcont">
                <div class="basicrow m-bott-ii">
                    <div class="userinfo full nomtops">
                        <div class="basicrow">
                            <div class="basicrow f-bmed roboto-b m-bott">
                                Resumen de Afiliaci&oacute;n
                            </div>

                            <div class="redstat">
                                <div class="autorow roboto-r pull-left debit-m-t-a">
                                    Afiliado a
                                </div>

                                <div class="autorow roboto-b pull-right debit-m-t-b">
                                    {{this.affiliate}}
                                </div>
                            </div>

                            <div class="redstat m-top-ii">
                                <div class="autorow roboto-r pull-left debit-m-t-a">
                                    M&eacute;todo de Pago
                                </div>

                                <div class="autorow roboto-b pull-right debit-m-t-b">
                                    {{this.bank}}
                                </div>
                            </div>

                            <div class="redstat m-top-ii">
                                <div class="autorow roboto-r pull-left debit-m-t-a">
                                    N&uacute;mero de Cuenta
                                </div>

                                <div class="autorow roboto-b pull-right debit-m-t-b">
                                    ************{{this.infoAfiliation.mAccountNo}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
